<template>
  <PubPage>
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :pageTotal="pageTotal"
      :pagination="false"
      @searchBack="searchBack"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-green"
            icon="plus-circle"
            @click="add('add', '')"
            >添加角色</a-button
          >
        </div>
      </template>

      <template slot="operation" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="add('edit', record)"> <a-icon type="form" />编辑 </a>
          <!-- <a @click="changePermiss(record)" class="green">
            <a-icon type="control" />编辑权限
          </a> -->
          <a @click="delRole(record.id)" class="orange">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddRole ref="addRoleModal" @ok="moduleOk" />
    <ChangePermiss ref="changePermissModal" />
  </PubPage>
</template>

<script>
import { Setting } from "@/api";
import AddRole from "./AddRole";
import ChangePermiss from "./ChangePermiss";
const columns = [
  {
    title: "角色名称",
    dataIndex: "name",
    width: 100,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    hideInSearch: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: true,
    hideInSearch: true,
  },
];
export default {
  components: {
    AddRole,
    ChangePermiss,
  },
  data() {
    return {
      form: {
        name: "",
      },
      loading: false,
      list: [],
      columns,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取数据
    getList() {
      this.loading = true;
      Setting.findAllRole(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
        }
        this.loading = false;
      });
    },
    // 搜索回调
    searchBack(data) {
      this.form = { ...this.form, ...data };
      this.getList();
    },

    add(type, data) {
      this.$refs.addRoleModal.open(type, data);
    },
    changePermiss(data) {
      this.$refs.changePermissModal.open(data);
    },

    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },
    delRole(id) {
      let that = this;
      this.pubMsg
        .confirm("确定删除？")
        .then(() => {
          that.loading = true;
          Setting.deleteRole({
            ids: id,
          }).then(res => {
            if (res.code == this.config.pubCode) {
              that.getList();
            }
            that.loading = false;
          });
        })
        .catch(() => {
          console.log("56");
        });
    },
  },
};
</script>
